import {
  Button,
  FormControlLabel,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  padding: '40px 96px',
  minHeight: '100vh',
  switch: {
    padding: 0,
  },
}));

export const TitlePageStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.gray,
  margin: '38px 0',
}));

export const HeaderContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 50,
  alignItems: 'center',
});

export const SectionTitleStyled = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: 16,
  color: theme.palette.global.lightgray,
  margin: '32px 0',
}));

export const DivDeleteStyled = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  color: 'red',
  cursor: 'pointer',
  '&:hover': {
    color: '#c4342d',
  },
});

export const SectionStyled = styled('div')({
  display: 'flex',
  gap: 16,
  marginTop: 20,
});

export const RadioGroupStyled = styled(RadioGroup)({
  display: 'block',
  marginTop: -47,
  marginBottom: 5,
});

export const RadioButtonStyled = styled(FormControlLabel)(({ theme }) => ({
  color: theme.palette.global.gray,
}));

export const Input2Styled = styled(TextField)({
  width: '12%',
});

export const AccessPermissionStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 24,
  width: '100%',
  height: 64,
  marginBottom: 0,
});

export const SubmitContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
});

export const ButtonSubmitStyled = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  width: 240,
  height: 42,
  fontSize: '12px',
  color: theme.palette.global.white,
  fontWeight: 700,
  marginTop: 64,
}));
